import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFooter,{attrs:{"app":"","color":"grey lighten-1"}},[_c(VSpacer),_c('span',{staticClass:"overline"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" SECRETARÍA GENERAL - Sistema de control de oficios V."+_vm._s(_vm.version))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }